module.exports = __webpack_public_path__ + "img/16581298_L.0f8399f1.png";